import {go, Model} from '@/models'

const Beep = new Model('beeper/beeps')

const Source = new Model('beeper/sources')

const Account = new Model('beeper/accounts', {
  idProp: 'code'
})

function findTagCloud(params) {
  return go('get', 'beeper/tags', params)
}

function findStats(what, params) {
  return go('get', 'beeper/stats/' + what, params)
}

export {
  Model, go, Beep, Source, findTagCloud, Account, findStats
}
